import { ActionWithPayload } from "@obg/ngrx-utils";

import { MARKET_ACTION_TYPE } from "./market.action";
import { Market, MarketState } from "./market.model";

const initialState: MarketState = {
	currentMarket: {} as Market,
	markets: [],
};

export function marketReducer(state = initialState, action: ActionWithPayload): MarketState {
	switch (action.type) {
		case MARKET_ACTION_TYPE.getAllSuccess: {
			return {
				...state,
				...action.payload,
			};
		}
		default:
			return state;
	}
}
